// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IRegionalDistrictsGetByLocationIdRequest,
  TRegionalDistrictsGetByLocationIdModel,
  IMappers,
  TRegionalDistrictsGetByLocationIdResponse,
  TRegionalDistrictsGetByLocationIdResponse_1,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TRegionalDistrictsGetByLocationIdModel = {
  apiType: 'public',
  assertStatusCodes: [200],
  method: 'GET',
  microserviceName: 'geo',
  pathApi: '/v1/regional-districts/get-by-location-id/',
  interserviceAuthEnabled: true,
} as TRegionalDistrictsGetByLocationIdModel;

export function createRegionalDistrictsGetByLocationIdModel(
  parameters: IRegionalDistrictsGetByLocationIdRequest,
): TRegionalDistrictsGetByLocationIdModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IRegionalDistrictsGetByLocationIdOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IRegionalDistrictsGetByLocationIdRequest;
}

export async function fetchRegionalDistrictsGetByLocationId<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IRegionalDistrictsGetByLocationIdOptions<TResponse200>): Promise<
  TRegionalDistrictsGetByLocationIdResponse | TResponse200
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createRegionalDistrictsGetByLocationIdModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TRegionalDistrictsGetByLocationIdResponse_1);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TRegionalDistrictsGetByLocationIdResponse;
}
